import { useToast } from 'vue-toastification'
import i18n from '../../locales/i18n'
import {
  GetMessages
} from '@/api/message.js'

const toast = useToast()

const sortOptions = {
  user: { key: 'Sender', reverse: false },
  message: { key: 'Message', reverse: false },
  timestamp: { key: 'Created', reverse: false }
}

const state = () => ({
  messages: [],
  unreadTaskCount: 0,
  unreadByTask: {},
  currentSort: sortOptions.timestamp
})

// getters
const getters = {
}

// actions
const actions = {
  async getBaseData ({ commit }) {
    try {
      // fel
      const messagesResponse = await GetMessages()
      if (messagesResponse.status === 200) {
        const messageData = messagesResponse.data.Messages
        // commit('setTasks', taskdata.sort(function (a, b) { return ((a.CreatedDate > b.CreatedDate) ? -1 : ((a.CreatedDate < b.CreatedDate) ? 1 : 0)) }))
        commit('setMessages', messageData)

        const unreadMessagesData = messagesResponse.data.UnreadByTask
        let count = 0
        for (const key in unreadMessagesData) {
          if (unreadMessagesData[key] > 0) {
            count++
          }
        }
        commit('setUnreadTaskCount', count)
        commit('setUnreadByTask', unreadMessagesData)
      } else {
        toast.warning(i18n.global.t('taskPage.couldNotGetData'))
      }
    } catch (e) {
      console.log(e)
      toast.warning(i18n.global.t('taskPage.couldNotGetData'))
    }
  },
  setSort ({ commit, state }, option) {
    // If a different column is clicked, set it as the current sort column
    if (state.currentSort.key !== option.key) {
      commit('setCurrentSort', { key: option.key, reverse: false })
    } else {
      // If the same column is clicked again, toggle the order
      commit('setCurrentSort', { key: option.key, reverse: !state.currentSort.reverse })
    }

    // Apply sorting to the Messages array
    const sortedMessages = [...state.currentTask.Messages].sort((a, b) => {
      const aValue = a[state.currentSort.key]
      const bValue = b[state.currentSort.key]

      // Adjust the comparison based on the data type of the column
      if (typeof aValue === 'string') {
        return state.currentSort.reverse ? bValue.localeCompare(aValue) : aValue.localeCompare(bValue)
      } else {
        return state.currentSort.reverse ? bValue - aValue : aValue - bValue
      }
    })

    // Commit the mutation to update the store state
    commit('setSortedMessages', sortedMessages)
  },
  async updateUnreadTaskCount ({ commit, state }, count) {
    commit('setUnreadTaskCount', state.unreadTaskCount + count)
  }
}

const mutations = {
  setMessages (state, data) {
    state.messages = data
  },
  setUnreadTaskCount (state, data) {
    state.unreadTaskCount = data
  },
  setUnreadByTask (state, data) {
    state.unreadByTask = data
  },
  setSortedMessages (state, sortedMessages) {
    state.currentTask.Messages = sortedMessages
  },
  setCurrentSort (state, option) {
    state.currentSort = option
  }

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
